import Api from '@/api/api.js'

export default {

    /**
     * Liste des categories
     */
     categorie () {
        const promise = Api().get('/categorie-medicaments')
        return promise.then((response) => response.data)
    },

    /**
     * Liste des medicaments
     */
    medicaments () {
        const promise = Api().get('/medicaments')
        return promise.then((response) => response.data)
    },
    /**
     * Liste des medicaments par categorie
     */
    listeMedicaments () {
        const promise = Api().get('/medicaments/liste')
        return promise.then((response) => response.data)
    },
    /**
     * Liste des medicaments bien ordonnée
     */
    listeMedicamentsOrdonne () {
        const promise = Api().get("/medicaments/liste-ordonne");
        return promise.then((response) => response.data)
    },

    /**
     * Recuperer le medicament dont l'id est passer en paramètre
     * @param int id 
     */
    getMedicament (id) {
        const promise = Api().get('/medicament/'+id)
        return promise.then((response) => response.data)
    },

    /**
     * Appel au route pour importer une liste de médicament
     * @param {*} id 
     * @param {*} data 
     * @returns 
     */
    importMedicament(data) {
        const promise = Api().post('/medicaments/medicament-import', data)
        return promise.then((response) => response.data)
    },

    importConsommable(data) {
        const promise = Api().post('/consommables/consommable-import', data)
        return promise.then((response) => response.data)
    },

    /**
     * Supprimer un Médicament
     * @param {*} data 
     */
    deleteMedicament(data) {
        const promise = Api().put('/medicaments/delete', data)
        return promise.then((response) => response.data)
    },

  }